import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function runDocumentsReprocess(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENTS_REPROCESS,
    (organisationId, data) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}/reprocess/`,
          data || {},
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
